import React, { useCallback, useEffect } from "react";
import { AutocompleteComponent } from "../../Controls";
import { ReskinningAutocomplete } from "../../V2";
import { useDebouncedAction } from "../../../Hooks/DebouncedAction";
import { GetAllDevelopersContactsAPI } from "../../../Services";

const DeveloperAutocomplete = ({ value, onChange, multiple, isNewLayout }) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const getDevelopersSearch = useCallback(
    useDebouncedAction(async (searchText) => {
      setLoading(true);
      const result = await GetAllDevelopersContactsAPI({
        pageIndex: 1,
        pageSize: 100,
        search: searchText,
      });
      if ("result" in result) {
        const formattedData = result.result.map((item) => {
          const contact = JSON.parse(item.contact);
          return {
            developerId: item.developerId,
            developerName: contact?.contact.company_name ?? "",
            id: item.contactsId,
            mobile: contact?.contact.landline_number?.phone,
            email_address: contact?.contact.general_email?.email,
          };
        });
        setData(formattedData);
      }
      setLoading(false);
    }),
    []
  );

  useEffect(() => {
    getDevelopersSearch();
  }, [getDevelopersSearch]);

  if (isNewLayout) {
    return (
      <ReskinningAutocomplete
        data={data}
        isLoading={loading}
        onInputChange={(_e, value) => getDevelopersSearch(value)}
        displayLabel={(item) => item.developerName}
        multiple={multiple}
        getOptionSelected={(item, value) =>
          item.developerId === value.developerId
        }
        chipsLabel={(item) => item.developerName}
        selectedValues={value}
        onChange={onChange}
        withoutSearchButton
        filterOptions={(options, state) =>
          options.filter(
            (option) =>
              option.developerName
                .toLowerCase()
                .includes(state.inputValue.toLowerCase()) ||
              option.developerId === +state.inputValue
          )
        }
      />
    );
  }

  return (
    <AutocompleteComponent
      data={[...data]}
      isLoading={loading}
      onInputChange={(_e, value) => getDevelopersSearch(value)}
      displayLabel={(item) => item.developerName}
      multiple={multiple}
      getOptionSelected={(item, value) =>
        item.developerId === value.developerId
      }
      chipsLabel={(item) => item.developerName}
      selectedValues={value}
      onChange={onChange}
      withoutSearchButton
      filterOptions={(options, state) =>
        options.filter(
          (option) =>
            option.developerName
              .toLowerCase()
              .includes(state.inputValue.toLowerCase()) ||
            option.developerId === +state.inputValue
        )
      }
    />
  );
};

export default DeveloperAutocomplete;
